import React, { Component } from 'react'

import './NotFoundPage.css'

class NotFoundPage extends Component {
  componentWillMount(){
    document.title = "Cogsworth - Booking error"
  }

  promo(){
    return (
      <div className="promo">
        <p>But did you know you can get your own booking page for free with Cogsworth?</p>
        <p>Use coupon <em>404booking</em> to get 25% off all paid plans.</p>
        <a className="btn btn-primary" href={`${window.location.protocol}//${window.location.hostname}/account/auth/signup?utm_source=404`}>Sign up now</a>
      </div>
    )
  }

  errorMessage(){
    if (this.props.error === 'incorrect-token') {
      return <p>The provided token doesn't seem to be correct. Please check your URL and try again.</p>
    } else if (this.props.error === 'business-not-enabled') {
      return <p>This business is currently not available for booking.</p>
    } else if (this.props.error === 'no-ocurrences') {
      return <p>This recurring appointment doesn't have any future occurrences.</p>
    } else if (this.props.error === 'not-found') {
      return <p>No appointments were found.</p>
    } else if (this.props.error === 'adhoc-service-unavailable') {
      return <p>This ad-hoc meeting is no longer available, please contact the administrator to arrange another meeting.</p>
    } else if (this.props.error === 'no-staff-services') {
      return <p>This staff member is not assigned to any services.</p>
    } else {
      return <p>The link you provided doesn't seem to be correct. Please check your URL and try again.</p>
    }
  }

  render() {
    return (
      <div className="not-found-page">
        <div className="inner">
          <h1>Oops!</h1>
          { this.errorMessage() }
          { this.promo() }
        </div>
      </div>
    );
  }
}

export default NotFoundPage
